import { useState } from "react";
import { useDashboard } from "../../../lib/useDashboard";
import TopUsers from "../_shared/TopUsers/TopUsers";
import TopUsersPopup from "../_shared/TopUsers/TopUsersPopup";
import useTopEmployeesDepartment from "./useTopEmployeesDepartment";

function TopEmployeesDepartment({ col = 7, row = 8 }: { col?: number; row?: number } = {}) {

  const { selectedDepartment } = useDashboard();

  const {
    loading,
    error,
    fullMessage,
    top,
    top5,
    current,
    currentUserId,

    planTypes,
    setIsPeriod, isPeriod,
    typeId, setTypeId
  } = useTopEmployeesDepartment(selectedDepartment);

  const [open, setOpen] = useState(false)

  return (
    <>
      <TopUsers
        col={col}
        row={row}
        title='Топ сотрудников (отдел)'
        loading={loading}
        fullMessage={fullMessage}
        error={error}
        top={top5}
        currentUserId={currentUserId}
        current={current}
        setOpenPopup={() => setOpen(true)}
      />
      <TopUsersPopup 
        open={open}
        onClose={() => setOpen(false)}
        title='Топ сотрудников (отдел)'
        data={top}
        loading={loading}

        planTypes={planTypes}
        isPeriod={isPeriod}
        setIsPeriod={setIsPeriod}
        typeId={typeId}
        setTypeId={setTypeId}
      />
    </>
  )
}

export default TopEmployeesDepartment
